import { useQuery } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { fetchCreditBalance } from '@/services/credits';

/**
 * Остаток кредитов текущего пользователя.
 *
 * Ключ включает id пользователя: после смены сессии баланс предыдущего
 * не должен показываться новому даже мгновение.
 */
export function useCreditsQuery() {
  const { status, session } = useAuthSession();

  return useQuery({
    queryKey: ['credits', session?.user.id ?? null],
    queryFn: fetchCreditBalance,
    enabled: status === 'ready',
  });
}
